import { WithStyles, withStyles } from '@mui/styles';

import { AdminTransactionHistory } from './transactionHistory';
import { muiStyles } from './transactionHistoryStyles';

export interface AdminTransactionHistoryProps extends WithStyles<typeof muiStyles> {
    location: any;
}

export default withStyles(muiStyles)(AdminTransactionHistory);